import React from "react";
import TypographyInputs from "./TypographyInputs";
import TypographyDisplay from "./TypographyDisplay";

const TypographySizes = ({
  fonts,
  currentFont,
  setCurrentFont,
  mobileInputs,
  setMobileInputs,
  desktopInputs,
  setDesktopInputs,
  setSmallTypeSizeTags,
  setMediumTypeSizeTags,
}) => {
  const MOBILE_SIZES = [
    {
      label: "XS",
      sizeStart: 0,
      sizeEnd: 320,
    },
    {
      label: "S",
      sizeStart: 320,
      sizeEnd: 600,
    },
  ];

  const DESKTOP_SIZES = [
    {
      label: "M",
      sizeStart: 600,
      sizeEnd: 960,
    },
    {
      label: "L",
      sizeStart: 960,
      sizeEnd: 1076,
    },
    {
      label: "XL",
      sizeStart: 1076,
      sizeEnd: 1236,
    },
    {
      label: "XXL",
      sizeStart: 1076,
      sizeEnd: 1440,
    },
  ];

  function renderSelectData() {
    if (fonts) {
      const selectData = fonts.kit.families.map((item) => {
        return (
          <option key={item.id} value={item.css_names[0]}>
            {item.name}
          </option>
        );
      });

      return (
        <select
          name="selectList"
          id="selectList"
          onChange={(event) => setCurrentFont(event.target.value)}
          value={currentFont}>
          {selectData}
        </select>
      );
    }
    return null;
  }

  return (
    <>
      {renderSelectData()}
      <div className="typography-sizes-container">
        <div className="typography-preview-container">
          <TypographyInputs label="Mobile" inputs={mobileInputs} setInputs={setMobileInputs} />
          <TypographyDisplay
            inputs={mobileInputs}
            sizes={MOBILE_SIZES}
            currentFont={currentFont}
            setTypeSizeTags={setSmallTypeSizeTags}
          />
        </div>
        <div className="typography-preview-container">
          <TypographyInputs label="Desktop" inputs={desktopInputs} setInputs={setDesktopInputs} />
          <TypographyDisplay
            inputs={desktopInputs}
            sizes={DESKTOP_SIZES}
            currentFont={currentFont}
            setTypeSizeTags={setMediumTypeSizeTags}
          />
        </div>
      </div>
    </>
  );
};

export default TypographySizes;
